import { Injectable } from '@angular/core';
import { HomeService } from '../../home/home.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { resturlConstants } from '../../../rest-url/resturlconstants';
import { environment } from '../../../environments/environment';

@Injectable()
export class CcLoansService {
  constructor(private http: HttpClient, private homeService: HomeService) { }

  getCCLoanSummary(): Observable<any> {
    return this.http.post<any>(resturlConstants.ccLoansUrl, {
      'userId': localStorage.getItem('userId'),
      'clientShortCode': environment.clientShortCode
    },
      {
        headers: new HttpHeaders()
          .set('Content-Type', 'application/json')
          .set('Authorization', this.homeService.getAuthHeader())
      });
  }
}
